import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getCityFromSlug } from '../routes/seoRoutes';

export const TestPage: React.FC = () => {
  const { city: urlCitySlug } = useParams<{ city: string }>();
  const location = useLocation();
  
  const cityName = urlCitySlug ? getCityFromSlug(urlCitySlug) : undefined;

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Test Page - Route Parameters</h1>
      
      <div className="bg-gray-100 p-6 rounded-lg space-y-4">
        <div>
          <strong>Current Path:</strong> {location.pathname}
        </div>
        <div>
          <strong>URL City Slug:</strong> {urlCitySlug || 'undefined'}
        </div>
        <div>
          <strong>Converted City Name:</strong> {cityName || 'undefined'}
        </div>
        <div>
          <strong>Location Search:</strong> {location.search}
        </div>
        <div>
          <strong>Location Hash:</strong> {location.hash}
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-bold mb-4">Test URLs:</h2>
        <ul className="space-y-2">
          <li>
            <a href="/vendi-la-tua-auto-reggio-emilia" className="text-blue-600 hover:underline">
              /vendi-la-tua-auto-reggio-emilia
            </a>
          </li>
          <li>
            <a href="/valuta-la-tua-auto-milano" className="text-blue-600 hover:underline">
              /valuta-la-tua-auto-milano
            </a>
          </li>
          <li>
            <a href="/acquisto-auto-istantaneo-roma" className="text-blue-600 hover:underline">
              /acquisto-auto-istantaneo-roma
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}; 